<template>
    <div class="index">
        <div class="model">
            <div class="body">
                <p class="title"></p>
                <p class="content"></p>
                <p class="btns" style="display:none">
                    <span class="cancel">取消</span>
                    <span class="confirm">确定</span>
                </p>
                <p class="foot"></p>    
            </div>
        </div>
        <div class="loading" id="loading" v-show="loading"><div class="circle"></div></div>
        <div class="main" id="indexPage" v-if="pageStatus == 1">
            <img src="../images/index_top.png" alt="" width="100%">
            <div class="banner">
                <img src="../images/index_wifilogo.png" width="31.733%">
                <p>一键连WiFi，一直有保障</p>
            </div>
            <div class="detail clearfix">
                <div class="protect">
                    <p>保障清单</p>
                    <div class="line left"></div>
                    <div class="line right"></div>
                </div>
                <div class="detail-item">
                    <div class="left">连WiFi意外损失累计最高赔付</div>
                    <div class="right">￥<span class="big">100,000</span>元</div>
                </div>
                <div class="detail-item">
                    <div class="left">连WiFi意外损失单次最高赔付</div>
                    <div class="right">￥<span class="big">20,000</span>元</div>
                </div>
                <div class="detail-item">
                    <div class="left">保障期限</div>
                    <div class="right">一年</div>
                </div>
                <div class="detail-item">
                    <div class="left">参保费用</div>
                    <div class="right">￥<span class="big">0.00</span>元</div>
                </div>
                <div class="btn" @click="toRange()">查看保险详情</div>
            </div>
            <div class="detail clearfix">
                <div class="protect">
                    <p>专属特色</p>
                    <div class="line left"></div>
                    <div class="line right"></div>
                </div>
                <div class="left-panel">
                    <div class="icon icon1"></div>
                    <p style="color:#333333">全方位保障</p>
                    <p>所有通过WiFi万能钥匙</p>
                    <p>连WiFi的上网行为</p>
                </div>
                <div class="right-panel">
                    <div class="icon icon2"></div>
                    <p style="color:#333333">官方VIP通道</p>
                    <p>极速处理您的WiFi安全</p>
                    <p>险理赔需求</p>
                </div>
            </div>
            <qa :type="1"></qa>
            <div class="logo-image"></div>
            <div class="copyright">南京尚网网络科技有限公司对以上信息保留最终解释权</div>
            <p class="button" id="createBtn" @click="login" v-if="createBtn == 1" style="position: fixed;bottom:0;">免费参保</p>
            <p class="button" id="createBtn" @click="goCreate" v-if="createBtn == 2" style="position: fixed;bottom:0;">免费参保</p>
        </div>
        <div class="main" id="voucherPage" v-if="pageStatus == 2" style="margin-top:0;">
            <div class="title">
                <p class="zhongan">WiFi安全险</p>
                <div class="already" v-if="obj.status == 1">已参保</div>
                <div class="already" v-if="obj.status == 2" style="color:#0285F0">处理中</div>
                <p class="status" v-if="obj.status == 1"></p> 
                <p class="status" v-if="obj.status == 2"></p> 
                <div class="logo"></div>
                <div class="al-item" style="margin-top:16px">
                    <div class="left">累计最高赔付人民币</div>
                    <div class="right">￥100000元</div>
                </div>
                <div class="al-item">
                    <div class="left">单日/单次最高赔付人民币</div>
                    <div class="right">￥20000元</div>
                </div>
                <div class="al-item">
                    <div class="left">保障期限</div>
                    <div class="right">{{obj.start_time}}至2023年9月15日</div>
                </div>
                <div class="al-item">
                    <div class="left">支付金额</div>
                    <div class="right">￥0.00元</div>
                </div>
                <div class="al-item">
                    <div class="left">保险详细</div>
                    <a class="right a" @click="clickRange" href="#/range">保障范围</a>
                </div>
                <div class="al-item" style="padding-bottom:24px">
                    <div class="left">服务热线</div>
                    <a class="right a"  @click="range" href="tel:4009999595">400-999-9595</a>
                </div>
            </div>
            <qa :type="2"></qa>
            <div class="logo-image"></div>
            <div class="copyright">南京尚网网络科技有限公司对以上信息保留最终解释权</div>
            <div style="position:fixed;bottom:0;width:100%;margin-top:15px"><div class="bottom_btn" id="btn_claim" @click='goClaim' v-bind:class="{halfwidth:claimList}">我要索赔</div><router-link class="bottom_btn claimList" to="/claimList" v-show="claimList" v-bind:class="{halfwidth: claimList}" style="display:inline-block"><div @click="clickClaimList">索赔记录</div></router-link></div>
        </div>
    </div>
</template>

<script>
import qa from '@/components/qa'
  
const AES = require('@/lib/Utils/AES').default
export default {
  name: 'index',
  components: {
    qa
  },
  mounted:function(){
      var _self = this;
      Utils.Bridge.call('getAppInfo',{
            success:function(o){
                _self.appinfo = o;
                
                Utils.Bridge.call('checkLogin', {
                    success:function(bool){
                        if(bool){
                            _self.checkStatus();
                            _self.$trace.enterTraceDone({page: 1, login:'have_login'})
                        }else{
                            _self.$trace.enterTraceDone({page: 1, login: 'no_login'})
                            _self.pageStatus = 1;
                        }
                    }
                });
            }
        });
      // Utils.Tracker.send({
      //       data: {
      //           f: 'wifiins',
      //           b: "ins_in"
      //       }
      //   });
      Utils.Bridge.call('hideOptionMenu')
      setTimeout(_ => {
        Utils.Bridge.call('hideOptionMenu')
      }, 2000)
  },
  data () {
    return {
        msg: 'tests',
        obj:'',
        appinfo:'',
        createBtn:1,
        pageStatus : 0,
        loading:false,
        claimList:false,
        appid:this.$route.query.appid
    }
  },
    methods:{
      range(){
      },
        toRange:function(){
            if(this.appinfo.chanid == 'ivvi'){
                this.$router.push("/rangeIvvi");
                this.$trace.trace('ins_detail', {type: 'rangeIvvi'})
            }else if(this.appinfo.appid == 'A0009'){
                this.$router.push("/rangeA0009");
                this.$trace.trace('ins_detail', {type: 'rangeA0009'})
            }else if(this.appinfo.appid == 'I0010'){
                this.$router.push("/rangeIos");
                this.$trace.trace('ins_detail', {type: 'rangeIos'})
            }else{
                this.$router.push("/range");
                this.$trace.trace('ins_detail', {type: 'range'})
            }
            console.log(`查看保险详情`)
        },
        clickRange(){
            this.$trace.trace('ins_mine_detail', 'ind')
            console.log(`点保障范围`)
        },
        clickClaimList(){
            this.$trace.trace('ins_mine_record', 'ind')
            console.log(`点索赔记录`)
        },
        goCreate:function(){
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: "ins_freepro"
            //     }
            // });
            this.$trace.trace('ins_join', 'have_login')
            console.log(`参保：已登录`)
            sessionStorage.removeItem('PERSONAL_INFO')
            this.$router.push("/create");
        },
        goClaim:function(){
            this.$trace.trace('ins_mine_claim')
            console.log(`我要索赔`)
            if(this.obj.status == 2){
                safe.model({
                    title:'温馨提示',
                    content:'您有一笔保单正在索赔中，不能提交新的索赔',
                    foot:'我知道了'
                });
                safe.bindModelEvent();
                return;
            }else{
                this.$router.push('/claimStep1')
            }
        },
        checkStatus:function(){
            var _self = this;
            _self.loading = true;

            let data = {
              "dhid": _self.appinfo.dhid,
              "uhid": _self.appinfo.uhid,
              "vcode": _self.appinfo.vcode
            }
            let ed = AES.Encrypt( JSON.stringify(data), AES.obj())

            this.$http.post(_host + '/user/get',{
                ed: ed
            },{
                emulateJSON: true
            }).then(function(response){
                _self.loading = false;
                var json = response.body;
                if(json.c=='0000'){
                    document.title='我的保障';

                    _self.pageStatus = 2;
                    _self.$trace.enterTraceDone({page: 2})
                    _self.obj = json.m;
                    _self.obj.end_time = _self.obj.end_time || '2023年9月15日24时';
                    var status   = json.m.status,
                        hasList  = json.m.has_list;
                    if(status=='2'){
                        $('body').addClass('claim');
                    }
                    if(hasList=='2'){
                        $('.bottom_btn').css('width','50%');
                        _self.claimList = true;
                    }
                }else{
                    _self.pageStatus = 1;
                    _self.createBtn = 2;
                }
            })
        },
        login:function(){
            var _self = this;
            var trackerB = '';
            if($(this).attr('id')=='createBtn'){
                trackerB='ins_freepro_login';
            }else{
                trackerB='ins_mypro';
            }
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: trackerB
            //     }
            // });
            _self.$trace.trace('ins_join', 'no_login')
            console.log(`参保：未登录`)

            Utils.Bridge.call("login", {
                fromSource: "app_insurance",
                loginMode: 0,
                success:function(ok){
                  
                  // 自动登录
                  if (ok || _self.$wkb.isWKBrowser === "ios") {
                    Utils.Bridge.call('getAppInfo',{
                      success:function(o){
                          _self.appinfo = o;

                        let data = {
                          "dhid": _self.appinfo.dhid,
                          "uhid": _self.appinfo.uhid,
                          "vcode": _self.appinfo.vcode
                        }
                        let ed = AES.Encrypt( JSON.stringify(data), AES.obj())

                        _self.$http.post(_host + '/user/get',{
                            ed: ed
                        },{
                            emulateJSON: true
                        }).then(function(response){
                            _self.loading = false;
                            var json = response.body;
                            if(json.c=='0000'){
                                document.title='我的保障';

                                _self.pageStatus = 2;
                                _self.obj = json.m;
                                _self.obj.end_time = _self.obj.end_time || '2023年9月15日24时';
                                var status   = json.m.status,
                                    hasList  = json.m.has_list;
                                if(status=='2'){
                                    $('body').addClass('claim');
                                }
                                if(hasList=='2'){
                                    $('.bottom_btn').css('width','50%');
                                    _self.claimList = true;
                                }
                            }else{
                                sessionStorage.removeItem('PERSONAL_INFO')
                                _self.$router.push("/create");
                            }
                          })
                        }
                      });
                    }
                }
            });
        },
        noCreate:function(){
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: 'ins_mypro_pop'
            //     }
            // });
            safe.model({
                title:'温馨提示',
                content:'抱歉，您暂时还未参保，请先点击免费参保',
                foot:'我知道了'
            });
            safe.bindModelEvent();
        }
    }
}
</script>

<style scoped>
    .halfwidth{width: 50% !important;}
    .main{
        width: 100%;
        overflow-x: hidden;
        margin: 0 auto;
    }
    .banner{
        padding: 4% 4.8%;
        margin-bottom: 11px;
        background: #fff;
    }
    .banner p{
        padding: 0;
        color: #787878;
        font-size: 13px;
        line-height: 21px;
    }
    .protect{
        position: relative;
        text-align: center;
    }
    .protect p{
        font-size: 16px;
        line-height: 60px;
        color: #000;
        font-weight: 600;
    }
    .protect .line{
        position: absolute;
        top:29px;
        width: 34.66%;
        height:1px;
        background: #E8E8E8;
    }
    .protect .left{
        left:-1%;
    }
    .protect .right{
        right:-1%;
    }
    .detail-item{
        height:32px;
        line-height: 32px;
        font-size: 14px;
    }
    .detail-item .left{
        float: left;
        color: #626262;
        vertical-align: middle;
        height: 32px;
        font-weight: 300;
    }
    .detail-item .right{
        float: right;
        color: #151515;
        vertical-align: middle;
        height:32px;
    }
    .detail-item .big{
        float: none;
        font-size: 22px;
        color: #3474b8;
        margin: 0 3px;
    }
    .detail .btn{
        color: #0285F0;
        font-size: 14px;
        line-height: 60px;
    }
    .detail .left-panel,.detail .right-panel{
        position: relative;
        display: inline-block;
        width: 49%;
        padding: 0;
        margin: 0;
        padding-bottom: 43px;
    }
    .detail .right-panel{
        
    }
    .detail .icon{
        width: 100%;
        padding-top: 28%;
        margin-top: 26px;
        margin-bottom: 17px;
    }
    .icon1{
        background: url(../images/index/icon1.png) no-repeat center;
        background-size: contain;
    }
    .icon2{
        background: url(../images/index/icon2.png) no-repeat center;
        background-size: contain;
    }
    .detail .left-panel p,.detail .right-panel p{
        padding: 0;
        margin: 0;
        color: #3F3F3F;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
    }
    .logo-image{
        margin-top: 30px;
        width: 100%;
        padding-top: 2.9%;
        background: url(../images/index/logo-image.png) no-repeat center;
        background-size: contain;
    }
    .copyright{
        font-size: 12px;
        line-height: 26px;
        color: #E0E0E0;
        text-align: center;
        font-weight: 300;
        padding-bottom: 60px;
    }
    .title .already{
        font-size: 14px;
        line-height: 26px;
        color: #666666;
        font-weight: 400;
        padding-bottom: 14px;
        border-bottom: 1px solid #E8E8E8;
    }
    .al-item{
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        font-weight: 400;
    }
    .al-item .left{
        float: left;
    }
    .al-item .right{
        float: right;
    }
    .al-item .a{
        display: block;
        text-decoration: underline;
        color: #0285f0;
    }
</style>



// WEBPACK FOOTER //
// Index.vue?ac413458